export const REGISTER_ERROR = 'REGISTER_ERROR';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const UNREGISTER_SUCCESS = 'UNREGISTER_SUCCESS';
export const UNREGISTER_ERROR = 'UNREGISTER_ERROR';

export const LOAD_DEVICE_SUCCESS = 'LOAD_DEVICE_SUCCESS';
export const LOAD_DEVICES_SUCCESS = 'LOAD_DEVICES_SUCCESS';
export const UPDATE_DEVICE_SUCCESS = 'UPDATE_DEVICE_SUCCESS';
export const UPDATE_DEVICES_SUCCESS = 'UPDATE_DEVICES_SUCCESS';
export const UNLOAD_DEVICES_DONE = 'UNLOAD_DEVICES_DONE';
export const DELETE_DEVICE_SUCCESS = 'DELETE_DEVICE_SUCCESS';

export const UPDATE_DEVICE_TOKEN_SUCCESS = 'UPDATE_DEVICE_TOKEN_SUCCESS';
export const UPDATE_DEVICE_TOKEN_ERROR = 'UPDATE_DEVICE_TOKEN_ERROR';

export const NOTIFICATION_SENDING = 'NOTIFICATION_SENDING';
export const NOTIFICATION_ERROR = 'NOTIFICATION_ERROR';
export const NOTIFICATION_SUCCESS = 'NOTIFICATION_SUCCESS';
export const NOTIFICATION_RECEIVED = 'NOTIFICATION_RECEIVED';



// WEBPACK FOOTER //
// ./src/core/devices/action-types.js